import { http } from "./client";

export const fetchEmailNotifications = () => http.get("EmailNotifications");

export const updateEmailNotification = ({ eventId, ...payload }) =>
    http.put(`EmailNotifications/${eventId}`, payload);
